import React, { PureComponent } from 'react';
import { Icon } from './elements';

class BluePaperClip extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <Icon viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.93062 19.8635C-0.677868 17.2944 -0.629252 13.1514 1.99249 10.5916L11.3568 1.4484C13.3352 -0.483364 16.551 -0.483535 18.5296 1.4484C20.489 3.36149 20.4914 6.44821 18.5296 8.36356L10.3667 16.326C9.03389 17.6273 6.85629 17.6091 5.54607 16.2835C4.28379 15.0063 4.32428 12.9821 5.61089 11.7258L12.028 5.46865C12.304 5.19959 12.7562 5.19498 13.0381 5.45838L14.0587 6.41203C14.3406 6.67547 14.3454 7.10714 14.0694 7.3762L7.65299 13.6328C7.43281 13.8478 7.41924 14.205 7.62406 14.4123C7.81924 14.6097 8.12607 14.613 8.32442 14.4193L16.4873 6.4569C17.3629 5.60199 17.3629 4.2101 16.4868 3.35472C15.6302 2.51834 14.2566 2.51791 13.3996 3.35472L4.03526 12.4979C2.48334 14.0132 2.45941 16.4661 3.98209 17.9658C5.5004 19.4612 7.95464 19.4631 9.47576 17.978L17.157 10.478C17.4328 10.2087 17.885 10.2039 18.1671 10.4671L19.1884 11.4201C19.4705 11.6833 19.4756 12.115 19.1998 12.3843L11.5186 19.8842C8.85893 22.481 4.55683 22.4502 1.93062 19.8635Z"
          fill="#033297"
        />
      </Icon>
    );
  };
}

export default BluePaperClip;
